import * as GQL from '~/graphql/generated/client';

/**
 * Format assignees for display
 * Single: "John Doe"
 * Multiple: "John Doe and 2 others"
 */
export const formatAssignees = (assignees: GQL.AssigneeInfo[]): string => {
  if (!assignees || assignees.length === 0) {
    return 'Unknown';
  }
  if (assignees.length === 1) {
    return assignees[0].assignedToName ?? assignees[0].assignedTo;
  }
  const firstName = assignees[0].assignedToName ?? assignees[0].assignedTo;
  const othersCount = assignees.length - 1;
  return `${firstName} and ${othersCount} other${othersCount > 1 ? 's' : ''}`;
};

/**
 * Convert status enum to display label
 */
export const getStatusLabel = (status: GQL.AssignmentStatusType): string => {
  switch (status) {
    case GQL.AssignmentStatusType.Completed:
      return 'Completed';
    case GQL.AssignmentStatusType.Rejected:
      return 'Rejected';
    default:
      return 'Pending';
  }
};

/**
 * Check if task has multiple stakeholders
 */
export const isMultiStakeholder = (task: GQL.UserTask): boolean => {
  return task.assignees && task.assignees.length > 1;
};
